import BaseEntity from '@/entities/BaseEntity';
import Rule from '@/entities/Rule';
import RuleChange from '@/entities/RuleChange';
import User from '@/entities/User';

export default class RuleChangeLog extends BaseEntity {
  id = null;
  user = null;
  rule = null;
  changes = [];
  created_at = new Date();

  _entityFields = {
    rule: Rule,
    user: User,
  };

  _entityArrayFields = {
    changes: RuleChange,
  };

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
